<template>
  <section class="container">
    <TextBeta
      tag="h2"
      class="heading"
    >Explore More Opportunities</TextBeta>
    <div class="categories-wrapper">
      <ul
        v-if="categories.length"
        class="categories"
      >
        <li
          v-for="category in categories"
          :key="category.slug"
        >
          <LinkButton
            :to="{ name: 'category', params: { category: category.slug } }"
            class="link"
          >{{ category.name }}</LinkButton>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import categories from '@/store/modules/categories';

  import TextBeta from './TextBeta';
  import LinkButton from './LinkButton';

  export default {
    components: {
      TextBeta,
      LinkButton,
    },
    computed: mapState(['categories']),
    created() {
      const { $store } = this;

      $store.registerModule('categories', categories);

      $store.dispatch('categories/fetch');
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .container {
    padding-top: spacing(beta);
    padding-bottom: spacing(beta);
    background-color: color(linen);
  }

  .categories-wrapper {
    @include container;

    .heading + & {
      margin-top: spacing(base-zeta);
    }
  }

  .categories {
    @include column;

    display: flex;
    margin-right: auto;
    margin-left: auto;
    width: percentage(10 / 12);
    flex-direction: column;
    justify-content: space-around;
    text-align: center;

    @include breakpoint(phablet) {
        flex-direction: row;
    }
  }

  .heading {
    color: color(slate);
    text-align: center;
  }

  .link {
    color: color(bronze);
  }
</style>
